module.exports = __webpack_public_path__ + "img/已抢光.8e597ca0.png";